import React from 'react'
import { Tooltip } from '../../../../shared/components/text/tooltip/Tooltip'
import { cropRow } from '../../../../shared/lib/helpers/crop-row'

interface ProjectsCellProps {
  projects: string[]
}

export const ProjectsCell = ({ projects }: ProjectsCellProps) => {
  const { visible, hidden } =
    projects.length === 1
      ? { visible: projects[0], hidden: [] as string[] }
      : cropRow(projects, 25)

  return (
    <div className={'flex w-fit items-center gap-[8px]'}>
      <span className={'truncate'}>{visible}</span>
      {!!hidden.length && (
        <Tooltip title={hidden.join(', ')}>
          <span
            className={
              'ml-auto cursor-default rounded-[4px] bg-focus-50 p-[4px] text-[13px] leading-[13px] text-aqua-300'
            }
          >
            +{hidden.length}
          </span>
        </Tooltip>
      )}
    </div>
  )
}
